import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { CalendarEvent, CalendarView, DAYS_OF_WEEK } from 'angular-calendar';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { addHours, endOfWeek, format, startOfWeek } from 'date-fns';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { Webflow } from 'src/app/utils/webflow';

registerLocaleData(localeFr);

@Component({
  selector: 'mwl-demo-utils-calendar-header',
  template: `
    <div class="d-flex justify-content-between">
        <div>
            <span class="h3 mr-3">
                {{ viewDate | calendarDate:(view + 'ViewTitle'):locale:weekStartsOn }}
            </span>
            <div class="btn-group">
                <div title="précédent" class="btn-sm text-dark" style="cursor:pointer;" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="emitWeekRange()">
                    <i class="fas fa-chevron-left"> </i>
                </div>
                <div title="aujourd'hui" class="btn-sm text-dark" style="cursor:pointer;" mwlCalendarToday [(viewDate)]="viewDate" (viewDateChange)="emitWeekRange()">
                    <i class="fas fa-circle" style="font-size: x-small;"> </i>
                </div>
                <div title="suivant" class="btn-sm text-dark" style="cursor:pointer;" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="emitWeekRange()">
                    <i class="fas fa-chevron-right"> </i>
                </div>
            </div>
        </div>
    </div>
    <br />
    <div [ngSwitch]="view">
        <mwl-calendar-month-view *ngSwitchCase="'month'" [viewDate]="viewDate" [events]="events" [locale]="locale"
            [weekStartsOn]="weekStartsOn" [weekendDays]="weekendDays"
            [activeDayIsOpen]="activeDayIsOpen" >
        </mwl-calendar-month-view>
        <mwl-calendar-week-view *ngSwitchCase="'week'" [viewDate]="viewDate" [events]="events" [locale]="locale"
            [weekStartsOn]="weekStartsOn" [weekendDays]="weekendDays"
    (hourSegmentClicked)="userType=='artist' && onHourSegmentClick($event)">
        </mwl-calendar-week-view>
        <mwl-calendar-day-view *ngSwitchCase="'day'" [viewDate]="viewDate" [events]="events" [locale]="locale">
        </mwl-calendar-day-view>
    </div>
    <br />
  `
})
export class CalendarHeaderComponent implements OnChanges {

  @Input() view: CalendarView;

  // gerant or artist calendar
  @Input() userType: string;

  @Input() events: CalendarEvent;

  @Input() viewDate: Date;

  @Input() locale: string = 'fr';

  @Output() viewChange = new EventEmitter<CalendarView>();

  @Output() viewDateChange = new EventEmitter<Date>();

  @Output() timeRangeSelected = new EventEmitter<{ start: any, end: any }>();

  @Output() emittedSelectedDate = new EventEmitter<Date>(); // Emit new event

  CalendarView = CalendarView;

  weekStartsOn: number = DAYS_OF_WEEK.MONDAY;

  weekendDays: number[] = [DAYS_OF_WEEK.FRIDAY, DAYS_OF_WEEK.SATURDAY];

  activeDayIsOpen: boolean = true;

  clickedDate: Date;

  // Track the start time selected
  onHourSegmentClick(event: { date: Date }): void {
    const currentDate = moment(); // Current date and time
    const clickedDate = moment(event.date).minute(0); // Clicked date and time

    // Check if clicked date is in the past
    if (clickedDate.isBefore(currentDate, 'minute')) {
      Swal.fire({
        title: "Attention",
        text: `Vous ne pouvez pas sélectionner une date ou une heure passée.`,
        icon: "error",
        position: "top",
      });
      Webflow.setIFrameHeight();
      return; // Prevent any further action
    } else {
      this.emittedSelectedDate.emit(event.date);
    }
  }

  emitWeekRange() {
    if (!this.viewDate) return; // Guard against undefined viewDate
    const startOfWeekDate = startOfWeek(this.viewDate, { weekStartsOn: this.weekStartsOn as 0 | 1 | 2 | 3 | 4 | 5 | 6 });
    const endOfWeekDate = endOfWeek(this.viewDate, { weekStartsOn: this.weekStartsOn as 0 | 1 | 2 | 3 | 4 | 5 | 6 });

    const formattedStart = format(startOfWeekDate, 'yyyy-MM-dd');
    const formattedEnd = format(endOfWeekDate, 'yyyy-MM-dd');

    // Emit the formatted start and end dates
    this.timeRangeSelected.emit({ start: formattedStart, end: formattedEnd });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['viewDate'] && changes['viewDate'].firstChange) {
      this.emitWeekRange();
    }
  }

}
